export default __webpack_public_path__ + "static/media/passchanged.c8425592.svg";